export const ProductString = {
    title: 'Prodotti',
    addProduct: 'Aggiungi Prodotto',
    name:'Nome',
    opening_date: 'Data Apertura',
    closing_date: 'Data Chiusura',
    action: 'Azioni',
    status_active : 'Attivo',
    status_suspended : 'Sospeso',
    status_disabled : 'Disabilitato',
    status_expired : 'Scaduto',
    
    

}